import { ActionType, ProColumns } from '@ant-design/pro-components';
import { Form } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CollapseWrapper from 'base/ui/components/CustomCollapse';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchForm } from 'pages/Components/SearchBox';
import SaveReportForm from 'pages/Components/reportForm';
import { SearchModel } from 'pages/model';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineDownload } from 'react-icons/ai';
import { CustomerGeneral } from 'services/Main/customerGeneralReport_services';
import { customerGeneralReportPresenter, customerGeneralReportStore, uiStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { getSaleOrgCode } from 'utils/localStorageHelper';
import { checkPermission } from 'utils/permissionHelper';
import { useResizableColumns } from 'utils/reportHelper';
import SelectSearch from './SelectSearch';
import { defaultColumn } from './column';



const createCustomerGeneralReport = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=================================================//
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const tableRef = useRef<ActionType>();

    //--- DATA TABLE ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      currentCompanyCode: getSaleOrgCode()
    });

    const [dataReport, setDataReport] = useState<CustomerGeneral[]>([])

    const [loading, setLoading] = usePartialState({
      btnRunReport: false
    })

    const [columns, setColumns] = useState<ProColumns[]>(defaultColumn);
    // Loading
    const [exportLoading, setExportLoading] = useState(false);


    // lấy data báo cáo =============================================================================
    const getDataReport = async (dataSearch: object) => {
      await customerGeneralReportPresenter.getDataReport(customerGeneralReportStore, dataSearch);
      if (customerGeneralReportStore.dataReport.isSuccess) {
        const dataTemp = cloneDeep(customerGeneralReportStore.dataReport.data);
        setDataReport(dataTemp);
        return dataTemp;
      }
      setDataReport([]);
      return [];
    }


    const CheckValueText = (value?: string) => {
      if (value === 'Có dữ liệu') {
        return true
      } else if (value === 'Không có dữ liệu') {
        return false
      } else {
        return null
      }
    }


    // ============================================LƯU MẪU BÁO CÁO =========================================

    const constDataName = 'BCTHTTKH';
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns(columns, setColumns, constDataName);


    return (
      <PageWrapper
        breadcrumb={[{
          text: 'Báo cáo tổng hợp khách hàng'
        }]}
      >
        <BoxContainer>
          <CollapseWrapper title={'Tìm kiếm'}>
            <SearchForm initialValues={{ actived: true }} form={form} column="col-2"
              onFinish={async (value) => {
                setLoading({ btnRunReport: true })

                setDataPaging({
                  paging: {
                    pageSize: PAGE_SIZE_DEFAULT,
                    pageIndex: 1,
                  },
                  currentCompanyCode: getSaleOrgCode(),
                  ...Object.fromEntries(Object.entries(value).filter(([_, e]) => {
                    if (typeof e === 'boolean') {
                      return true
                    } else if (Array.isArray(e) && e.length === 0) {
                      return false
                    }
                    else {
                      return !!e
                    }
                  })),

                  searchProfileForeignCodeIsNull: CheckValueText(value.profileForeignCode),
                  addressIsNull: CheckValueText(value.address),
                  taxNoIsNull: CheckValueText(value.taxNo),
                  customerTypeCodeIsNull: CheckValueText(value.customerTypeCodeIsNull),
                  customerSourceCodeIsNull: CheckValueText(value.customerSourceCodeIsNull),
                  provinceIdIsNull: CheckValueText(value.provinceIdIsNull),
                  districtIdIsNull: CheckValueText(value.districtIdIsNull),
                  wardIdIsNull: CheckValueText(value.wardIdIsNull),
                  customerCareerCodeIsNull: CheckValueText(value.customerCareerCodeIsNull),
                  customerGroupCodeIsNull: CheckValueText(value.customerGroupCodeIsNull),
                  salesEmployeeCodeIsNull: CheckValueText(value.salesEmployeeCodeIsNull),

                })
                tableRef.current?.reload()

                setLoading({ btnRunReport: false })

              }
              }
            >
              <SelectSearch form={form} />
              <div className='col-span-2 mt-5 flex justify-center items-center'>
                <CustomButton loading={loading.btnRunReport} type='primary' onClick={() => {
                  form.submit()
                }}>
                  Chạy báo cáo
                </CustomButton>
              </div>
            </SearchForm>
          </CollapseWrapper>

          <CustomProTable
            columns={defaultColumn}
            rowKey="stt"
            size="small"
            dataSource={dataReport}
            search={false}
            scroll={{ x: 7000, y: 400 }}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              const data = await getDataReport({
                ...dataPaging,
              });
              return {
                data: data,
                success: customerGeneralReportStore.dataReport.isSuccess,
              };
            }}

            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: customerGeneralReportStore.dataReport.paging?.totalCount,
            }}


            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            toolBarRender={() => [
              <>
                {/* {checkPermission('EXPORT') ? ( */}
                <CustomButton
                  size="middle"
                  loading={exportLoading}
                  onClick={async () => {
                    setExportLoading(true);
                    await customerGeneralReportPresenter.exportExcel({ ...dataPaging, lang: uiStore.language });
                    setExportLoading(false);
                  }}
                  className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                  type="primary"
                >
                  <AiOutlineDownload className="block text-base" />
                  <span className="block">{t('btn.export')}</span>
                </CustomButton>
                {/* ) : (
                  ''
                )} */}
              </>,
              // nút lưu mẫu bc
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
          />
        </BoxContainer>
      </PageWrapper>
    )
  })
}

export default createCustomerGeneralReport